import axios from "axios";
import { message } from 'antd';
import UserStore from "../stores/UserStore";
const url = process.env.REACT_APP_BACKEND_URL;
const ethMultiplier = 1000000000000000000;
export async function getAllWagers() {
    return axios({
        method: 'get',
        url: url + "/wagers"
    }).then(res => {
        return res.data;
    });
}

export async function getSingleWager(wagerId) {
    return axios({
        method: 'get',
        url: url + "/wagers?wagerId=" + wagerId,
    }).then(res => {
        return res.data;
    });
}

export async function getSingleEventWagers(eventId) {
    return axios({
        method: 'get',
        url: url + "/wagers?eventId=" + eventId,
    }).then(res => {
        return res.data;
    });
}

export async function getSingleEventWagersAgainstTeam(eventId, teamChoice) {
    return axios({
        method: 'get',
        url: url + "/wagers/against?eventId=" + eventId + "&teamChoice=" + teamChoice,
       
    }).then(res => {
        return res.data;
    });
}

export async function getSingleEventWagersForTeam(eventId, teamChoice) {
    return axios({
        method: 'get',
        url: url + "/wagers/for?eventId=" + eventId + "&teamChoice=" + teamChoice,
       
    }).then(res => {
        return res.data;
    });
}

export async function getSingleEventWagersValueOdds(eventId, value, odds) {
    return axios({
        method: 'get',
        url: url + "/wagers?eventId=" + eventId + "&value=" + value + "&odds=" + odds,
    }).then(res => {
        return res.data;
    });
}

export async function getAllUserWagers(userId) {
    axios({
        method: 'get',
        url: url + "/wagers?userId=" + userId,
    }).then(res => {
        UserStore.updateBets(res.data);
             
        return res.data;
    });
}

export async function getUserMakerWagers(userId) {
    return axios({
        method: 'get',
        url: url + "/wagers?maker=" + userId,
    }).then(res => {

        return res.data;
    });
}

export async function getUserTakerWagers(userId) {
    return axios({
        method: 'get',
        url: url + "/wagers?taker=" + userId,
    }).then(res => {

        return res.data;
    });
}

export async function makeWager(
    authToken,
    userId,
    bytes32Id,
    eventId,
    maker,
    value,
    odds,
    makerChoice,
    settled,
    cancelled,
    isPropWager,
    originalEventId,
    isPrivate
) {
    return axios.post(url + "/wagers?userId=" + userId, {
        bytes32Id,
        eventId,
        maker,
        value,
        odds,
        makerChoice,
        settled,
        cancelled,
        isPropWager,
        originalEventId,
        isPrivate
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            message.info("Success, wager made!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error making wager.");
            console.log(error);
        });
}


export async function takeWager(authToken,
    userId,
    wagerId,
    bytes32Id,
    value,
    taker,
    eventId,
    makerChoice
) {
    return axios.post(url + "/wagers/take?wagerId=" + wagerId, {
        userId,
        bytes32Id,
        value,
        taker,
        eventId,
        makerChoice

    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            message.success("Success, wager taken!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error taking wager. It is possible another user managed to confirm their transaction first. Please refresh wagers and try again.");
            console.log(error);
        });
}

export async function submitVote(authToken, wagerId, bytes32Id) {
    return axios.post(url + '/wagers/vote?wagerId=' + wagerId, {
        bytes32Id       
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }

        }).then(function (response) {
            message.success("Success, vote submit!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error submitting vote in database, ensure the transaction has been successfully mined.");
            console.log(error);
        });
}

export async function submitSecondVote(authToken, wagerId, bytes32Id) {
    return axios.post(url + '/wagers/second-vote?wagerId=' + wagerId, {
        bytes32Id       
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }

        }).then(function (response) {
            message.success("Success, vote submit!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error submitting vote in database, ensure the transaction has been successfully mined.");
            console.log(error);
        });
}

export async function finalizeBet(authToken, wagerId, bytes32Id, eventBytes32Id) {
    return axios.post(url + '/wagers/finalize?wagerId=' + wagerId, {
        bytes32Id,
        eventBytes32Id       
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }

        }).then(function (response) {
            message.success("Success, bet finalized!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error finalizing bet in database, ensure the transaction has been successfully mined.");
            console.log(error);
        });
}


export async function cancelWager(authToken,
    userId,
    wagerId,
    bytes32Id
) {
    return axios.post(url + "/wagers/cancel?wagerId=" + wagerId, {
        userId,
        bytes32Id

    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            message.success("Success, wager cancelled!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error cancelling wager in database, ensure the cancel transaction has been successfully mined.");
            console.log(error);
        });
}


// WEBPACK FOOTER //
// ./src/api-calls/wagers.js